import { Field, FieldProps, getIn } from 'formik';
import { ReactNode } from 'react';

import { Slider } from '../../components';

interface Props {
  name: string;
  label: ReactNode;
  min?: number;
  max?: number;
  defaultValue: number;
  tooltip?: ReactNode;
  currencySymbol?: string;
  type?: 'default' | 'bordered';
}

export default function SliderWithNumberField({ name, ...bag }: Props) {
  return (
    <Field name={name}>
      {({ field: { value }, form: { setFieldValue, errors } }: FieldProps) => {
        function handleChange(value: number) {
          setFieldValue(name, value);
        }

        const error = getIn(errors, name);

        return (
          <div>
            <Slider.WithNumberInput value={value} onChange={handleChange} error={error} {...bag} />
          </div>
        );
      }}
    </Field>
  );
}
